export const SET_ACCOUNT = 'setAccount'
export const DESTROY_ACCOUNT = 'destroyAccount'
export const GET_ACCOUNT = 'getAccount'
